import { Box } from "@mui/material";
import noImage from "../../assets/icons/no_image.svg";
import styles from "./BabySizeImage.module.scss";

interface BabySizeImageProps {
  src: string;
  alt: string;
}

const BabySizeImage: React.FC<BabySizeImageProps> = ({ src, alt }) => {
  return (
    <Box className={styles.babySizeImageWrapper}>
      <Box
        component="img"
        loading="lazy"
        src={src}
        alt={alt}
        onError={(e) => {
          const target = e.target as HTMLImageElement;
          target.onerror = null;
          target.src = noImage;
          target.style.width = "46px";
          target.style.height = "46px";
        }}
        className={styles.babySizeImage}
      />
    </Box>
  );
};

export default BabySizeImage;

